var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", xl: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("peppol-settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-select", {
                            staticClass: "mts",
                            attrs: {
                              items: _vm.extraFieldNames,
                              label: _vm.$ct("peppol-gln"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.PeppolGlnEV,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolGlnEV", $$v)
                              },
                              expression: "config.PeppolGlnEV",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-input-autocomplete", {
                            attrs: {
                              label: _vm.$ct("peppol-iban"),
                              items: _vm.filteredBankTypes,
                              fancy: "",
                            },
                            on: {
                              "item-click": function ($event) {
                                return _vm.peppolIbanClicked($event)
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (p) {
                                  return [
                                    _vm._v(" " + _vm._s(p.item.Iban)),
                                    _c("br"),
                                    _vm._v(" " + _vm._s(p.item.Bic) + " "),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.config.PeppolIban,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolIban", $$v)
                              },
                              expression: "config.PeppolIban",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-input", {
                            attrs: { label: _vm.$ct("peppol-bic"), fancy: "" },
                            model: {
                              value: _vm.config.PeppolBic,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolBic", $$v)
                              },
                              expression: "config.PeppolBic",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "use-invoice-number-as-payment-reference"
                              ),
                            },
                            model: {
                              value:
                                _vm.config.UseInvoiceNumberAsPaymentReference,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "UseInvoiceNumberAsPaymentReference",
                                  $$v
                                )
                              },
                              expression:
                                "config.UseInvoiceNumberAsPaymentReference",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("include-product-barcode"),
                            },
                            model: {
                              value: _vm.config.IncludeBarCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "IncludeBarCode", $$v)
                              },
                              expression: "config.IncludeBarCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-divider"),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("send-copy-to-bookkeeper"),
                            },
                            model: {
                              value: _vm.config.PeppolSendCopyToBookkeeper,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "PeppolSendCopyToBookkeeper",
                                  $$v
                                )
                              },
                              expression: "config.PeppolSendCopyToBookkeeper",
                            },
                          }),
                          _vm.config.PeppolSendCopyToBookkeeper
                            ? _c(
                                "span",
                                { staticClass: "bookkeeper-email-info mls" },
                                [
                                  _vm.bookkeeperEmail
                                    ? [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.bookkeeperEmail) +
                                            ")"
                                        ),
                                      ]
                                    : _c(
                                        "w-link",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit("change-tab", 2)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$ct("set-bookkeeper-email")
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("peppol-send-enabled-by-default"),
                            },
                            model: {
                              value: _vm.config.PeppolSendEnabledByDefault,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "PeppolSendEnabledByDefault",
                                  $$v
                                )
                              },
                              expression: "config.PeppolSendEnabledByDefault",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showAutoSendPeppolSettings
                    ? [
                        _c("w-divider"),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              [
                                _c("w-info", {
                                  staticClass: "mts",
                                  attrs: {
                                    "ico-lib": "fas",
                                    tiny: "",
                                    text: _vm.$ct(
                                      "auto-send-sales-via-peppol-info"
                                    ),
                                  },
                                }),
                                _c("w-checkbox", {
                                  attrs: {
                                    label: _vm.$ct(
                                      "auto-send-sales-via-peppol-nightly"
                                    ),
                                  },
                                  model: {
                                    value: _vm.autoSendPeppolSettings.SendSales,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.autoSendPeppolSettings,
                                        "SendSales",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "autoSendPeppolSettings.SendSales",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              [
                                _c("w-date-picker", {
                                  attrs: {
                                    fancy: "",
                                    disabled:
                                      !_vm.autoSendPeppolSettings.SendSales,
                                    nullable: "",
                                    label: _vm.$ct(
                                      "auto-send-sales-via-peppol-from-date"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.autoSendPeppolSettings
                                        .SendSalesFromDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.autoSendPeppolSettings,
                                        "SendSalesFromDate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "autoSendPeppolSettings.SendSalesFromDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.isDevMode
                    ? [
                        _c("w-divider"),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("w-checkbox", {
                                  attrs: {
                                    label: _vm.$ct(
                                      "send-invoice-response-on-approve"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.config.PeppolInvoiceResponseSettings
                                        .SendOnApprove,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config
                                          .PeppolInvoiceResponseSettings,
                                        "SendOnApprove",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "config.PeppolInvoiceResponseSettings.SendOnApprove",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("w-checkbox", {
                                  attrs: {
                                    label: _vm.$ct(
                                      "send-invoice-response-on-create-purchase"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.config.PeppolInvoiceResponseSettings
                                        .SendOnCreatePurchase,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config
                                          .PeppolInvoiceResponseSettings,
                                        "SendOnCreatePurchase",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "config.PeppolInvoiceResponseSettings.SendOnCreatePurchase",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c("w-divider"),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: !_vm.config.DontIncludePdfInPeppolUbl,
                              label: _vm.$ct("dont-include-pdf-in-peppol-ubl"),
                            },
                            on: {
                              input: function ($event) {
                                _vm.config.DontIncludePdfInPeppolUbl = !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.config.DontIncludePdfInPeppolUbl
                        ? _c(
                            "w-col",
                            [
                              _c("w-select", {
                                attrs: {
                                  items: _vm.layoutItems,
                                  label: _vm.$ct("peppol-layout"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.config.PeppolLayoutID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.config, "PeppolLayoutID", $$v)
                                  },
                                  expression: "config.PeppolLayoutID",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("w-divider"),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.peppolNoteFieldItems,
                              label: _vm.$ct("peppol-note-field"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.PeppolNoteField,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolNoteField", $$v)
                              },
                              expression: "config.PeppolNoteField",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.peppolPoFieldItems,
                              label: _vm.$ct("peppol-po-field"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.PeppolPoField,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolPoField", $$v)
                              },
                              expression: "config.PeppolPoField",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.peppolDeliveryFieldItems,
                              label: _vm.$ct("peppol-delivery-field"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.PeppolDeliveryField,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "PeppolDeliveryField", $$v)
                              },
                              expression: "config.PeppolDeliveryField",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _vm.$wf.isMdUp
                    ? _c(
                        "w-button",
                        {
                          attrs: { icon: "save" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-col", { attrs: { sm: "12", md: "6" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }